export const queryKeys = {
  brokerageDivisions: ['brokerageDivisions'] as const,
};
